import React, { Component } from 'react';
import { Button, Card, Col, Form, Input, message, Row } from 'antd';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { BackBtn } from '@comm/BackBtn';
import FlowOp from '@comm/workflow/submitOp';
import { queryIncuAddressInfo } from '@api/incubator/address';
import { queryDeleteBack, querySaveBack } from '@api/incubator/back';
import ModalFileList from '../comm/ModalFileList';
import TableFile from '../comm/TableFile';

const FormItem = Form.Item;
class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      detail: {},
      fileList: this.props.data ? this.props.data.files : [],
      customUuid: '',
      submiting: false,
    };
  }

  componentWillMount() {}

  componentDidMount() {
    const {
      params: { addressUuid },
    } = this.props;
    if (addressUuid) {
      this.getAddressDetail(addressUuid);
    }
  }

  componentWillReceiveProps(nextProps) {}

  getAddressDetail = addressUuid => {
    queryIncuAddressInfo({
      uuid: addressUuid,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          detail: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  backSave = params => {
    this.setState({
      submiting: true,
    });
    querySaveBack(params).then(res => {
      this.setState({
        submiting: false,
      });
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.replace(`/incubator/back_manage`);
      } else {
        message.error(res.message);
      }
    });
  };

  handleDelete = uuid => {
    queryDeleteBack({ uuid }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.replace(`/incubator/release_manage`);
      } else {
        message.error(res.message);
      }
    });
  };

  handleFileVisible = flag => {
    this.setState({
      fileVisible: !!flag,
    });
  };

  handleChooseFile = params => {
    this.setState({
      fileList: params,
      showFileTips: params.length === 0,
    });
  };

  validateFile = () => {
    const { fileList } = this.state;
    if (!fileList.length) {
      message.warn('没有选择附件！');
      this.setState({
        showFileTips: true,
      });
      return false;
    }
    return true;
  };

  submit = op => e => {
    if (e) {
      e.preventDefault();
    }
    const { data } = this.props;
    const { fileList, payableList } = this.state;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (!this.validateFile()) {
          return;
        }
        if (data && data.uuid) {
          values.uuid = data.uuid;
        }
        const params = {
          ...values,
          price: payableList.reduce((prev, curr) => prev + curr.price, 0),
          files: fileList,
          payableUuids: payableList.map(item => item.uuid),
        };
        if (op === 'audit') {
          this.backSave(params);
        } else {
          message.warn('保存草稿功能正在开发，敬请期待！');
        }
      }
    });
  };

  handleCustomChange = (e, option) => {
    this.customUuid = e;
    this.setState({
      customUuid: e,
    });
    this.props.form.setFieldsValue({ custom: option.props.children });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { fileVisible, showFileTips, fileList, customUuid, submiting, detail } = this.state;
    const { data, incuInfo } = this.props;
    const ItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
    };

    const ItemLayout2 = {
      labelCol: { span: 3 },
      wrapperCol: { span: 20 },
    };
    getFieldDecorator('company', { initialValue: data ? data.company : '' });
    getFieldDecorator('custom', { initialValue: data ? data.custom : '' });
    getFieldDecorator('companyUuid', {
      initialValue: data ? data.companyUuid : incuInfo.companyUuid,
    });
    return (
      <Form>
        <div style={{ marginBottom: 15 }}>
          <BackBtn />
          <FlowOp handleClick={this.submit} loading={submiting} />
          {data && data.uuid ? (
            <Button
              icon="delete"
              style={{ marginRight: 10 }}
              onClick={() => this.handleDelete(data.uuid)}
            >
              删除
            </Button>
          ) : null}
        </div>
        <Card title="地址释放申请">
          <Row>
            <Col span={10}>
              <FormItem label="孵化器名称" {...ItemLayout}>
                {detail.incubatorName}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <FormItem label="地址占用客户" {...ItemLayout}>
                {detail.customName}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <FormItem label="详细地址" {...ItemLayout}>
                {detail.name}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={20}>
              <FormItem label="相关附件" {...ItemLayout2}>
                {customUuid ? <a onClick={() => this.handleFileVisible(true)}>选择附件</a> : null}
                {showFileTips ? (
                  <span style={{ color: 'red', paddingLeft: '10px' }}>附件必须上传！</span>
                ) : null}
                {fileList.length > 0 ? (
                  <TableFile dataSource={fileList} handleChooseFile={this.handleChooseFile} />
                ) : null}
              </FormItem>
            </Col>
            <Col span={20}>
              <FormItem label="说明" {...ItemLayout2}>
                {getFieldDecorator('reason', {
                  rules: [{ required: true, message: '请输入reason!' }],
                  initialValue: data ? data.reason : '',
                })(
                  <Input.TextArea
                    placeholder="说明"
                    type="textarea"
                    autosize={{ minRows: 3, maxRows: 9 }}
                    maxLength={1000}
                  />,
                )}
                <span style={{ fontSize: '12px', color: '#999' }}>*最多可输入1000字</span>
              </FormItem>
            </Col>
          </Row>
        </Card>
        {fileVisible ? (
          <ModalFileList
            customUuid={customUuid}
            fileVisible={fileVisible}
            selectedRows={fileList}
            handleCancel={this.handleFileVisible}
            handleChooseFile={this.handleChooseFile}
          />
        ) : null}
      </Form>
    );
  }
}

export default connect(state => ({
  incuInfo: state.incubator_base,
}))(Form.create({ wrappedComponentRef: true })(BaseForm));



// WEBPACK FOOTER //
// ./src/components/incubator/release/FormBase.js